export default { // computed
    isSuperadminLoggedSchool: state => !!state.superadminLoggedSchool,

    isDistrictLoggedSchool: state => !!state.districtLoggedSchool,
}
